import $ from 'jquery'


export const initUvoting = () => {
  $("body").on("click", ".uvotingitem-vote", onVoteClick)
}
// DOM events
const onVoteClick = (e) => {
  e.preventDefault();
  const path = e.currentTarget.dataset.url
  if (path) {
    $.get(path + ".ajax", {vote: 1}, onVoteRequestRespond)
  }
}
const onVoteRequestRespond = (result) => {
  const resultWrapper = document.querySelector(".voting-result")
  if (resultWrapper) {
    resultWrapper.innerHTML = result
    resultWrapper.classList.add("active")
  }
}